const mainElement = document.getElementById('MainContent');

const reviewsObserver = new MutationObserver((m) => {
  m.forEach((mut) => {
    let reviews = document.querySelector('.main-widget.yotpo-display-wrapper')
    if(reviews){
      if(!reviews.querySelector('.custom-reviews-header')){
        const parentElement = document.querySelector('.main-widget.yotpo-display-wrapper > span.yotpo-display-wrapper > :first-child');
        const reviewsHeader = document.createElement('h3');
        reviewsHeader.innerText = 'Customer Reviews';
        reviewsHeader.classList.add('h3', 'custom-reviews-header');
        parentElement.insertBefore(reviewsHeader, parentElement.firstChild);
      }
    }
  })
})

reviewsObserver.observe(mainElement, { childList: true, subtree: true });